export const SEGMENTS = [
    { value: 'all', label: 'All Visitors' },
    { value: 'first_time_visitor', label: 'First Time Visitors' },
    { value: 'returning_visitor', label: 'Returning Visitors' },
    { value: 'buyer', label: 'Buyers' },
    { value: 'is_customer', label: 'Is Customer' },
    { value: 'is_not_customer', label: 'Is Not Customer' },
]